// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1oLQy","rootNoMargin":"styles_rootNoMargin__jnKOm"};